import borders from '../borders'

export const imageTheme = {
  borders: {
    curve: borders.sm,
    round: borders.full,
    square: 0
  },
  size: {
    xs: '40px',
    sm: '80px',
    md: '120px',
    lg: '160px',
    xl: '200px'
  }
}
